import { captureException } from '@sentry/vue'

export function useSentry() {
  const handleError = (error: Error) => {
    captureException(error)
  }

  return {
    handleError
  }
}
